module.exports = __webpack_public_path__ + "static/media/equipment-info.78f3e652.svg";